import React, { useState, useMemo } from "react";
import errorText from "../../../img/icons/text-error.svg";
import "./style.css";

const NewProjectSection = (props) => {
  const [newProjTitle, setNewProjTitle] = useState("");
  const [newProjDesc, setNewProjDesc] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const projectTitles = useMemo(() => {
    return props.options ? props.options.map((e) => e["title"]) : [];
  }, [props.options]);

  /**
   * Handles the change event for the project title input.
   *
   * @param {Event} event - The change event.
   */
  const handleOnChange = (event) => {
    const inputValue = event.target.value;
    setNewProjTitle(inputValue);
    props.setNewProjTitle(inputValue);

    if (projectTitles.includes(inputValue)) {
      setErrorMessage(props.projectNameErrorText);
    } else {
      setErrorMessage("");
    }
  };

  /**
   * Handles the change event for the project description input.
   *
   * @param {Event} event - The change event.
   */
  function handleDescChange(event) {
    const inputValue = event.target.value;
    setNewProjDesc(inputValue);
    props.setNewProjDesc(inputValue);
  }

  return (
    <div className="new-project-container">
      <div className="new-project-container-wrapper">
        <span className="subtitle-small">{props.newProjectTitle}</span>
        <div className="new-project-container-name">
          <label
            htmlFor=""
            className="body-small-greyscale new-project-container-name-text"
          >
            {props.newProjectNameText}
          </label>
          <input
            type="text"
            className="new-project-container-name-input"
            value={newProjTitle}
            onChange={handleOnChange}
            aria-invalid={errorMessage.length > 0}
            aria-describedby={errorMessage.length > 0 ? "projectNameError" : null}
          />
          {errorMessage.length === 0 ? (
            <></>
          ) : (
            <div id="projectNameError" className="new-project-container-error" aria-live="polite">
              <img
                src={errorText}
                width="16"
                height="16"
                className="new-project-container-error-icon"
                
              />
              <p className="body-extraSmall new-project-container-error-text">
                {errorMessage}
              </p>
            </div>
          )}
        </div>
        <div className="new-project-container-description">
          <label
            htmlFor=""
            className="body-small-greyscale new-project-container-description-text"
          >
            {props.newProjectDescriptionText}
          </label>
          <input
            type="text"
            value={newProjDesc}
            className="new-project-container-description-input"
            onChange={handleDescChange}
          />
        </div>
      </div>
    </div>
  );
};

export default NewProjectSection;
